import { Link } from 'react-router-dom';
import { movies, categories } from '@/mocks/movies';

export default function FeaturedMovies() {
  const featuredMovies = movies.filter((m) => m.featured);

  const getCategoryName = (slug: string) => {
    const cat = categories.find((c) => c.slug === slug);
    return cat ? cat.name : slug;
  };

  return (
    <section className="w-full px-4 md:px-6 py-8 md:py-10 bg-background-50" aria-label="精选推荐">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center justify-between mb-6">
          <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950">精选推荐</h2>
          <Link
            to="/category/movie"
            className="text-sm text-primary-600 hover:text-primary-700 flex items-center gap-1 cursor-pointer whitespace-nowrap"
          >
            更多精选 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {featuredMovies.map((movie) => (
            <Link
              key={movie.id}
              to={`/movie/${movie.id}`}
              className="group bg-background-50 border border-background-200/70 rounded-xl overflow-hidden transition-all hover:border-primary-200 cursor-pointer"
            >
              <div className="relative aspect-[3/4] overflow-hidden">
                <img
                  src={movie.poster}
                  alt={movie.title}
                  title={`${movie.title} - 天堂影院高清在线播放`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-2 right-2 flex items-center gap-1 bg-black/60 backdrop-blur-sm text-white text-xs px-2 py-1 rounded-md">
                  <i className="ri-star-fill text-accent-400 text-xs"></i>
                  <span>{movie.rating}</span>
                </div>
                <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent p-3 md:p-4">
                  <span className="inline-block text-xs text-white/90 bg-primary-500/80 px-2 py-0.5 rounded-md mb-1.5">
                    {getCategoryName(movie.category)}
                  </span>
                </div>
              </div>
              <div className="p-3 md:p-4">
                <h3 className="font-heading text-sm md:text-base font-semibold text-foreground-950 group-hover:text-primary-600 transition-colors line-clamp-1">
                  {movie.title}
                </h3>
                <div className="flex items-center gap-2 mt-1.5 text-xs text-foreground-500">
                  <span>{movie.year}</span>
                  <span>·</span>
                  <span>{movie.region}</span>
                </div>
                <div className="flex flex-wrap gap-1 mt-2">
                  {movie.genres.slice(0, 2).map((genre) => (
                    <span key={genre} className="text-xs px-1.5 py-0.5 rounded bg-secondary-100 text-secondary-700 whitespace-nowrap">
                      {genre}
                    </span>
                  ))}
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}